import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import InfoIcon from "@material-ui/icons/Info";
import { languages } from "../constants/languages";

export default class FinishedDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {languages.tournament.finished}
        </DialogTitle>
        <DialogContent style={{ width: 400, maxWidth: "97%", paddingTop: 0 }}>
          <Typography>{languages.tournament.finishedDescription1}</Typography>
          <br />
          <Typography>{languages.tournament.finishedDescription2}</Typography>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 10,
              marginTop: 16,
              marginBottom: 16,
              padding: "12px 14px",
              borderRadius: 6,
              backgroundColor: "rgba(0, 0, 0, 0.04)",
              border: "1px solid rgba(0, 0, 0, 0.08)",
            }}
          >
            <InfoIcon
              style={{
                height: 20,
                width: 20,
                marginTop: 1,
                flexShrink: 0,
                color: "rgba(0, 0, 0, 0.54)",
              }}
            />
            <Typography variant="body2" style={{ color: "rgba(0, 0, 0, 0.75)" }}>
              <strong>{languages.tournament.finishedCopyTipLabel}</strong>
              {" "}
              {languages.tournament.finishedCopyTip}
            </Typography>
          </div>
          <Typography>
            {languages.tournament.finishedDescription3 +
               languages.misc.supportEmail +
               "."}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.props.handleClose}
            variant="contained"
            color="primary"
            type="submit"
          >
            {languages.export.close}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
